module.exports = __webpack_public_path__ + "img/product2.37f39dcb.png";